:host {
  --uui-grid-spacing: 20px;
  --uui-grid-columns: 12;
}

.uui-grid {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  box-sizing: border-box;
  margin-left: calc(var(--uui-grid-spacing) / 2 * -1);
  margin-right: calc(var(--uui-grid-spacing) / 2 * -1);
}

.uui-grid.row {
  flex-direction: row;
}

.uui-grid.column {
  flex-direction: column;
}

@media (max-width: 991px) { 
  :host {
    --uui-grid-columns: 8;
  }
}
